import PropTypes from "prop-types"
import { Skeleton } from "@mui/material"
import classnames from "classnames"

export default function LoadingState({ periodAdjusted, selectedDateAdjusted }) {
  return (
    <div className={classnames("components_period-selector", {
      adjusted: periodAdjusted || selectedDateAdjusted,
    })}
    >
      <Skeleton variant="text" width={240} />
    </div>
  )
}

LoadingState.propTypes = {
  periodAdjusted: PropTypes.bool,
  selectedDateAdjusted: PropTypes.bool,
}
